import Button from "components/buttons/Button/Button.component";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";

const SearchButton = ({ listingsCount, ...rest }) => (
  <Button
    size="lg"
    variant="contained"
    autoFocus
    startIcon={listingsCount > 0 && <SearchIcon />}
    {...rest}
  >
    {listingsCount > 0
      ? `${listingsCount.toLocaleString()} vehicles`
      : "No vehicles available"}
  </Button>
);

export default SearchButton;
